import ApiCaller from 'actions/ApiCaller';
import baseAjaxConfig from 'actions/BaseAjaxConfig';
export var DeactivateAccount;
(function (DeactivateAccount) {
    DeactivateAccount["REQUEST"] = "DEACTIVATE_ACCOUNT_REQUEST";
    DeactivateAccount["SUCCESS"] = "DEACTIVATE_ACCOUNT_SUCCESS";
    DeactivateAccount["ERROR"] = "DEACTIVATE_ACCOUNT_ERROR";
})(DeactivateAccount || (DeactivateAccount = {}));
export function fetchDeactivateAccountPageData(password) {
    return (dispatch) => {
        dispatch({
            type: DeactivateAccount.REQUEST
        });
        return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
            pathname: '/api/2/user/deactivate',
            acceptErrors: true,
            action: DeactivateAccount.REQUEST
        }), {
            password
        }).then(data => dispatch({
            type: DeactivateAccount.SUCCESS,
            data: data['RESPONSE']
        }), err => {
            return Promise.reject(dispatch({
                type: DeactivateAccount.ERROR,
                error: err['RESPONSE']
            }));
        });
    };
}
